import { render, staticRenderFns } from "./HealthIndex.vue?vue&type=template&id=37f16f86&"
import script from "./HealthIndex.vue?vue&type=script&lang=js&"
export * from "./HealthIndex.vue?vue&type=script&lang=js&"
import style0 from "./HealthIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports